module.exports = __webpack_public_path__ + "img/left-side-menu-scenario-settings.049f83ee.svg";